/*
 * fn: parseError
 *
 * Parses an error message or returns the generic error fallback
 *
 */
export const parseError = (e: unknown, fallback: string) =>
  (e instanceof Error
    ? e.message
    : typeof e === 'object' && e !== null && 'message' in e && typeof e.message === 'string'
      ? e.message
      : null) || fallback
